module.exports = __webpack_public_path__ + "img/Frame.20f42eff.png";